import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { Steps } from "../../components/Steps";
import Side from "../../components/Side";

import { authOnIdentity } from "./utils";

const Login = ({ history, t }) => {
  const dispatch = useDispatch();

  return (
    <Fragment>
      <div className="row">
        <div className="col no-padding">
          <div className="login-action">
            <div className="action-container position-absolute">
              <div className="text text-uppercase title">
                {t("login.title_1")}
              </div>
              <div className="text text-uppercase title">
                {t("login.title_2")}
              </div>
              <div className="text subtitle mt-4">{t("login.subtitle")}</div>
              <div className="action text-uppercase">
                <button
                  className="btn btn-success btn-lg text-uppercase mt-4"
                  onClick={() => authOnIdentity(dispatch, history)}
                >
                  {t("login.signin")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col col-12 col-xl-8">
          <Steps t={t} step={6}></Steps>
          <div className="row">
            <div className="col-md-10 col-lg-8 col-xl-10 col-center no-padding position-relative">
              <div>{t("login.paragraph_1")}</div>
              <div className="mt-3 font-weight-600">
                {t("login.paragraph_2")}
              </div>
              <div className="offer-container mt-5">
                <div className="mb-2">
                  <div className="d-flex align-items-center">
                    <div className="icon consumption"></div>
                    <span>
                      <span className="text-uppercase font-weight-600">
                        {t("login.consumption.title")}
                      </span>{" "}
                      {t("login.consumption.description")}
                    </span>
                  </div>
                </div>
                <div className="my-2">
                  <div>{t("login.consumption.subDescription_1")}</div>
                  <div>{t("login.consumption.subDescription_2")}</div>
                  <div className="mt-2">{t("login.consumption.day_1")}</div>
                  <ul>
                    <li>{t("login.consumption.subList_1")}</li>
                    <li>{t("login.consumption.subList_2")}</li>
                    {/* <li>{t("login.consumption.subList_3")}</li>
                    <li>{t("login.consumption.subList_4")}</li> */}
                  </ul>
                  <div>{t("login.consumption.day_2")}</div>
                  <ul>
                    <li>{t("login.consumption.subList_5")}</li>
                  </ul>
                  <div>{t("login.consumption.subDescription_3")}</div>
                  <div>{t("login.consumption.subDescription_4")}</div>
                  <div>
                    {t("login.consumption.subDescription_5")}&nbsp;
                    <a href="https://mobility.dufercoenergia.com">
                      {t("login.consumption.link")}
                    </a>
                  </div>
                </div>
              </div>
              {/* <div className="offer-container mt-5">
                <div className="mb-2">
                  <div className="d-flex align-items-center">
                    <div className="icon prepaid"></div>
                    <span>
                      <span className="text-uppercase font-weight-600">
                        {t("login.rechargeable.title")}
                      </span>{" "}
                      {t("login.rechargeable.description")}
                    </span>
                  </div>
                </div>
                <div className="my-2">
                  {t("login.rechargeable.subDescription")}
                </div>
              </div> */}
              {/* <div className="offer-container mt-5">
                <div className="mb-2">
                  <div className="d-flex align-items-center">
                    <div className="icon monthly"></div>
                    <span>
                      <span className="text-uppercase font-weight-600">
                        {t("login.flat.title")}
                      </span>{" "}
                      {t("login.flat.description")}
                    </span>
                  </div>
                </div>
                <div className="my-2">{t("login.flat.subDescription")}</div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="col col-12 col-xl-4">
          <Side></Side>
        </div>
      </div>
      <div className="row">
        <div className="col col-12 col-xl-8">
          <div className="row">
            <div className="col-md-10 col-lg-8 col-xl-10 col-center no-padding position-relative">
              <div className="login-title text-uppercase mt-5">
                {t("login.documents.title")}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="d-flex login-icons py-2 py-lg-5 justify-content-evenly">
            <div className="icon-container d-flex align-items-center flex-column">
              <div className="icon docs"></div>
              <div className="text">{t("login.documents.fiscalCode")}</div>
            </div>
            <div className="icon-container d-flex align-items-center flex-column">
              <div className="icon bank"></div>
              <div className="text">{t("login.documents.paymentMode")}</div>
            </div>
            <div className="icon-container d-flex align-items-center flex-column">
              <div className="icon plate"></div>
              <div className="text">{t("login.documents.plate")}</div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

Login.propTypes = {
  history: PropTypes.object,
  t: PropTypes.func,
};

export default Login;
